import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = (panel) => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Chip</h2>
          </div>

          <Chip label="Food" />
          <Chip label="Food" color="primary" />
          <Chip label="Chip Outlined" variant="outlined" />

          <Accordion
            codemirror={codemirror === "Chip"}
            onChange={handleCodemirror("Chip")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Chip label="Food" />

<Chip label="Food" color="primary" />

<Chip label="Chip Outlined" variant="outlined" />
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />
          <br />
          <Chip label="Food" size="small" />
          <Chip label="Food" color="primary" size="small" />
          <Chip label="Chip Outlined" variant="outlined" size="small" />

          <Accordion
            codemirror={codemirror === "ChipSmall"}
            onChange={handleCodemirror("ChipSmall")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Chip label="Food" size="small" />

<Chip label="Food" color="primary" size="small" />

<Chip label="Chip Outlined" variant="outlined" size="small" />
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
